var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenVendors(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.01,
    height: 23.015,
    viewBox: "0 0 23.01 23.015",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_876",
    "data-name": "Grupo 876",
    transform: "translate(0.094 0.085)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_608",
    "data-name": "Trazado 608",
    d: "M12.232,1.066l.1.362a2.425,2.425,0,0,0,3.979,1.178l.021-.019a.853.853,0,0,1,1.383.9,2.464,2.464,0,0,0,2.735,3.184h.005a.858.858,0,0,1,.682,1.507l-.026.022a2.463,2.463,0,0,0,.591,4.14l.341.148a.768.768,0,0,1-.208,1.464l-.407.05a2.433,2.433,0,0,0-1.706,3.769l.228.342a.763.763,0,0,1-.96,1.118l-.335-.163a2.434,2.434,0,0,0-3.488,2.261l.008.4a.751.751,0,0,1-1.393.413l-.194-.318a2.437,2.437,0,0,0-4.175,0l-.18.3A.758.758,0,0,1,7.826,21.7l.008-.357a2.444,2.444,0,0,0-3.5-2.271l-.319.155a.763.763,0,0,1-.96-1.118l.2-.3a2.467,2.467,0,0,0-1.73-3.82l-.352-.043a.768.768,0,0,1-.208-1.464l.323-.14a2.475,2.475,0,0,0,.593-4.16L1.6,7.955a.766.766,0,0,1,.608-1.345l.341.057A2.462,2.462,0,0,0,5.287,3.487l-.1-.333a.76.76,0,0,1,1.233-.8l.264.24a2.434,2.434,0,0,0,3.995-1.184l.093-.345A.758.758,0,0,1,12.232,1.066Z",
    transform: "translate(-0.088 -0.085)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_610",
    "data-name": "Trazado 610",
    d: "M19.17,12.327a6.809,6.809,0,0,1-2.8,5.525,6.712,6.712,0,0,1-7.929,0A6.8,6.8,0,1,1,19.17,12.327Z",
    transform: "translate(-0.994 -0.932)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_613",
    "data-name": "Trazado 613",
    d: "M15.484,11.676l-3.219,3.64L7.177,9.309",
    fill: "none",
    stroke: "#2c2c2c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenVendors);
export default __webpack_public_path__ + "static/media/open_vendors.53dea892820eef8b7b5cded23a74b23f.svg";
export { ForwardRef as ReactComponent };